import { Col, Divider, Input, Pagination, Row } from 'antd';
import { viewersApi } from 'api/viewUserApi';
import AddEditFormViewers from 'components/Common/Modal/AddEditFormViewers';
import { ViewerInfo } from 'models/viewers';
import * as React from 'react';
import { FaSearch } from 'react-icons/fa';
import { FiPlus } from 'react-icons/fi';
import style from '../Components.module.scss';
import ItemViewerList from '../ItemViewerList/ItemViewerList';
import ViewerInformation from '../ViewerInfo/ViewerInfo';

export interface ViewersProps {}

export default function Viewers(props: ViewersProps) {
  const [pagePlant, setPagePlant] = React.useState<number>(0);
  const isEvent: boolean = false;
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [isShowViewersDetail, setIsShowViewersDetail] = React.useState(true);
  const [itemViewer, setItemViewer] = React.useState<ViewerInfo>();
  const [viewersList, setViewerList] = React.useState<ViewerInfo[]>();

  React.useEffect(() => {
    (async () => {
      try {
        const res = await viewersApi.fetchViewers({ _limit: 10, _page: 0, search_label: null });
        setViewerList(res.data);
      } catch (error) {
        console.log('Failed to fetch student details', error);
      }
    })();
  }, []);

  const onChangeValue = async (e: any) => {
    const val = e.target.value;
    const res = await viewersApi.fetchViewers({
      _limit: 10,
      _page: 0,
      search_label: `&text_search=${val}`,
    });
    setViewerList(res.data);
  };

  const onChangePage = (page: number) => {
    setPagePlant(page - 1);
  };

  return (
    <>
      {isShowViewersDetail ? (
        <Row className={style.root}>
          <Row className={style.header_info}>
            <Divider orientation="left" plain style={{ fontWeight: 'bold' }}>
              List of viewer
            </Divider>
          </Row>
          <Row className={style.main}>
            <Row className={style.header_main}>
              <Input
                onPressEnter={(e) => onChangeValue(e)}
                size="large"
                placeholder="Search by email"
                prefix={<FaSearch />}
                className={style.search_header}
              />
              <FiPlus
                onClick={() => {
                  setIsModalVisible(!isModalVisible);
                }}
                className={style.btn_create}
                size={20}
              />
            </Row>
            <div className={style.main_table}>
              <Row className={style.header_table}>
                <Col className={style.item_header} span={7}>
                  EMAIL
                </Col>
                <Col className={style.item_header} span={6}>
                  CREATED TIME
                </Col>
                <Col className={style.item_header} span={7}>
                  NAME
                </Col>
                <Col className={style.item_header} span={4}>
                  STATUS
                </Col>
              </Row>
              <div className={style.content_table} id={style.style_4}>
                {/* {viewersList?.map((item, index) => { */}
                {viewersList?.map((item, index) => {
                  return (
                    index >= pagePlant * 10 &&
                    index < (pagePlant + 1) * 10 && (
                      <ItemViewerList
                        key={item.id}
                        item={item}
                        setItemViewer={setItemViewer}
                        setIsShowViewersDetail={setIsShowViewersDetail}
                      />
                    )
                  );
                })}
              </div>
            </div>
          </Row>
          <Row className={style.footer_list}>
            <Pagination
              size="small"
              pageSize={10}
              defaultCurrent={pagePlant + 1}
              total={viewersList?.length}
              onChange={onChangePage}
              showSizeChanger={false}
              showQuickJumper={false}
            />
          </Row>
        </Row>
      ) : (
        itemViewer && (
          <ViewerInformation
            isShowViewerDetail={isShowViewersDetail}
            setIsShowViewerDetail={setIsShowViewersDetail}
            setViewerList={setViewerList}
            itemViewer={itemViewer}
            setItemViewer={setItemViewer}
          />
        )
      )}
      <AddEditFormViewers
        isEvent={isEvent}
        itemViewer={undefined}
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        setViewerList={setViewerList}
      />
    </>
  );
}
